export const DBTypes = {
  COMPANY: 'Company',
  PERIOD: 'period',
  PLAN_DETAILS: 'plan_details',
  COMPANY_SETTINGS: 'CompanySettings',
  BLACK_SCHOLES: 'black_scholes',
  CONTRIBUTION: 'contribution',
  OFFERING_PERIOD_CONTRIBUTIONS: 'offering_period_contributions',
  USER: 'User',
  EMAIL_DOMAIN: 'Email_Domain',
  PRE_REGISTER: 'Preregister',
  IMPORTS: 'imports',
  REPORT: 'report',
  OFFERING_PERIOD: 'offering_period',
  MODIFICATION: 'modification',
  CONTRIBUTION_START_DATE: 'contribution_period_start_date',
  SUMMARY: 'summary',
  STOCK_PRICES: 'stock_prices',
  RESET: 'reset',
  ACCOUNT: 'account',
  AUTOPAY: 'autopay',
  ACCOUNTSUMMARY: 'account_summary',
  FILE: 'file_signedurl',
};
